//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
import { EllipseImg } from '@cmp/images';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Testimonial extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { testimonial, className, t } = this.props;
    const componentClasses = classNames(styles.Testimonial, {
      [className]: className,
    });

    return (
      <div className={componentClasses}>
        <div className={styles.TestimonialContent}>
          <div className={styles.Ellipse}>
            <EllipseImg alt={t('accessibility_Testimonial')} />
          </div>
          <h3 className={styles.TestimonialText}>{testimonial.text}</h3>
          <h3 className={styles.TestimonialName}>{testimonial.name}</h3>
          <h3 className={styles.TestimonialRole}>{testimonial.role}</h3>
          <h3 className={styles.TestimonialHospital}>{testimonial.hospital}</h3>
          <h3 className={styles.TestimonialLocation}>{testimonial.location}</h3>
        </div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Testimonial);
